import React from 'react'
import { Stack, Heading, Text, Box, EmptyCard, Alert, Card } from '@/components/lib'
import TrialLocker from '../../includes/TrialLocker'
import DatabaseLocker from '../../includes/DatabaseLocker'
import useStore from '../../../store'
import utils from '@/utils/utils'

export default function Locks () {
  const { user, trial, updateTrial } = useStore()
  const canManage = utils.canManageTrial(user, trial)

  const handleTrialLockChange = (updatedTrial) => {
    if (updatedTrial) {
      updateTrial(trial._id, updatedTrial)
    }
  }

  const handleDatabaseLockChange = (updatedTrial) => {
    if (updatedTrial) {
      updateTrial(trial._id, updatedTrial)
    }
  }

  return (
    <Stack gap={5}>
      <EmptyCard icon='lock' title='Trial and database locking' description='Use locks to prevent changes to the trial configuration or the results database.' />

      <Card variant='outline' gap={2}>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Box flex={1}>
            <Heading as='h3' size='md' mb={2}>Trial Lock</Heading>
            <Text mb={3}>
              When the trial is locked, stages and datatypes cannot be edited. This prevents changes to the trial configuration and structure.
            </Text>
            <Text fontSize='sm' color='fg.muted' mb={4}>
              Use this lock when you want to prevent modifications to the trial setup while still allowing data entry and other operations.
            </Text>
          </Box>
          {canManage &&
            <Box ml={4}>
              <TrialLocker
                trial={trial}
                isLocking={!trial?.isLocked}
                onComplete={handleTrialLockChange}
              />
            </Box>}
        </Stack>
        <Alert status={trial?.isLocked ? 'info' : 'success'}>
          Status: {trial?.isLocked ? 'Trial is currently locked' : 'Trial is currently unlocked'}
        </Alert>
      </Card>

      <Card variant='outline' gap={2}>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Box flex={1}>
            <Heading as='h3' size='md' mb={2}>Database Lock</Heading>
            <Text mb={3}>
              When the database is locked, no new data can be created or edited within the trial. This includes responses, participants, queries, and notes.
            </Text>
            <Text fontSize='sm' color='fg.muted' mb={4}>
              Tasks, files, and messages will continue to work normally. Use this lock when you want to prevent data entry while still allowing operational management.
            </Text>
          </Box>
          {canManage &&
            <Box ml={4}>
              <DatabaseLocker
                trial={trial}
                isLocking={!trial?.isDatabaseLocked}
                onComplete={handleDatabaseLockChange}
              />
            </Box>}
        </Stack>
        <Alert status={trial?.isDatabaseLocked ? 'info' : 'success'}>
          Status: {trial?.isDatabaseLocked ? 'Database is currently locked' : 'Database is currently unlocked'}
        </Alert>
      </Card>
    </Stack>
  )
}
